<template>
    <div class="relative z-10 bg-inherit gap-4 tiptap ProseMirror col-span-full md:col-start-3 md:col-span-8 lg:!col-start-4 lg:col-span-6">
        <div class="lg:col-start-2 col-span-full md:col-span-7">
            <div class="view-h3 col-span-2">{{ title }}</div>
        </div>
        <div class="col-span-full md:col-span-8 lg:col-start-2 lg:col-end-11 text-body">
            <RenderedHTML :value="content?.['body']"></RenderedHTML>
        </div>
    </div>
</template>

<script lang="ts" setup>
import RenderedHTML from "~/components/view/RenderedHTML.vue"

const {get_value: get_localized_value } = useLocalizedValue()
const { content } = defineProps({
    content: {
        type: Object
    },
    image: {
        required: false,
        type: String
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    }
})

const title = computed(() => {
    if (content?.title) {
        return get_localized_value(content?.title)
    }
    return null
})

</script>